/**
 * Parses an itemcode out of a string, and returns an object with fields
 * `category`, `productcode` and `optionid`, or null if string does not
 * contain an itemcode.
 *
 * @return object the itemcode broken up into its category, productcode
 * and optionid parts. If the string is not a valid itemcode, returns null.
 */
export function parseItemcode(itemcode) {
   let matches = itemcode.match(/IF(\d{3})-(\d{3})-(\d{1,2})/);

   if (matches) {
      return {
         category: matches[1],
         productcode: matches[1] + matches[2],
         optionid: matches[3],
      };
   }

   return null;
}

export function constructItemcode(productcode, optionid) {
   let catCode = ('' + productcode).substring(0, 3);
   let pCode = ('' + productcode).substring(3, 6);
   let optionStr = optionid ? '-' + optionid : '';

   return 'IF' + catCode + '-' + pCode + optionStr;
}

export function constructSku(productcode, optionid) {
   return String(productcode) + String(optionid);
}
